import React, {Component} from 'react';
import SearchStatistics from "./SearchStatistics";
import TenderResults from "./Results/TenderResults";
import BackEnd from "../../backend/BackEnd";
import {userContext} from "../../auth/Auth";
import TenderRequestResults from "./Results/TenderRequestResults";

class SearchResults extends Component {
    static propTypes = {};
    static defaultProps = {
        pageSize: 6
    };
    state = {
        isLoading: false,
        newPageIndex: 0,
        activePageIndex: 0,
        underwayPageIndex: 0,
        archivedPageIndex: 0,
        incomingTrPageIndex: 0,
        acceptedTrPageIndex: 0,
        underwayTrPageIndex: 0,
        archivedTrPageIndex: 0,
        results: {},
        totalCount: 0,
        categoryCount: 0,
        tendersTab: 1,
        tenderRequestsTab: 1
    };

    async componentDidMount() {
        await this.search();
    }

    componentWillReceiveProps(nextProps) {
        const {query} = nextProps.match.params;

        this.setState({
            newPageIndex: 0,
            activePageIndex: 0,
            underwayPageIndex: 0,
            archivedPageIndex: 0,
            incomingTrPageIndex: 0,
            acceptedTrPageIndex: 0,
            underwayTrPageIndex: 0,
            archivedTrPageIndex: 0,
            results: {}
        }, () => this.search(query));
    }

    render() {
        const {query} = this.props.match.params;
        const loadingSpinner = <div className="text-center m-t-2">
            <i className="fa fa-circle-o-notch fa-spin fa-4x text-primary"/>
        </div>

        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <i className="page-header-icon ion-search"/>
                                Результаты поиска
                                {' '}
                                <span className="text-muted font-weight-light">
                                    по запросу "{query}"
                                </span>
                            </h1>
                        </div>
                    </div>
                </div>
                {
                    this.state.isLoading
                        ? loadingSpinner
                        : (
                            <div>
                                <SearchStatistics totalCount={this.state.totalCount}
                                                  categoryCount={this.state.categoryCount}/>
                                <hr className="page-wide-block m-t-0"/>
                                <div className="row">
                                    <div className="col-xl-offset-1 col-xl-10">
                                        {
                                            userContext.get().roleSystemName === 'Provider'
                                                ? <TenderRequestResults results={this.state.results}
                                                                        pageSize={this.props.pageSize}
                                                                        incomingPageIndex={this.state.incomingTrPageIndex}
                                                                        acceptedPageIndex={this.state.acceptedTrPageIndex}
                                                                        underwayPageIndex={this.state.underwayTrPageIndex}
                                                                        archivedPageIndex={this.state.archivedTrPageIndex}
                                                                        onIncomingPageChanged={pageIndex => this.updateState({incomingTrPageIndex: pageIndex})}
                                                                        onAcceptedPageChanged={pageIndex => this.updateState({acceptedTrPageIndex: pageIndex})}
                                                                        onUnderwayPageChanged={pageIndex => this.updateState({underwayTrPageIndex: pageIndex})}
                                                                        onArchivedPageChanged={pageIndex => this.updateState({archivedTrPageIndex: pageIndex})}
                                                                        tab={this.state.tenderRequestsTab}
                                                                        onChangeTab={tab => this.setState({tenderRequestsTab: tab})}/>
                                                : <TenderResults results={this.state.results}
                                                                 pageSize={this.props.pageSize}
                                                                 newPageIndex={this.state.newPageIndex}
                                                                 onNewPageChanged={pageIndex => this.updateState({newPageIndex: pageIndex})}
                                                                 activePageIndex={this.state.activePageIndex}
                                                                 onActivePageChanged={pageIndex => this.updateState({activePageIndex: pageIndex})}
                                                                 underwayPageIndex={this.state.underwayPageIndex}
                                                                 onUnderwayPageChanged={pageIndex => this.updateState({underwayPageIndex: pageIndex})}
                                                                 archivedPageIndex={this.state.archivedPageIndex}
                                                                 onArchivedPageChanged={pageIndex => this.updateState({archivedPageIndex: pageIndex})}
                                                                 tab={this.state.tendersTab}
                                                                 onChangeTab={tab => this.setState({tendersTab: tab})}/>
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                }
            </div>
        );
    }

    async updateState(state) {
        this.setState(state, () => {
            this.search();
        })
    }

    async search(query = this.props.match.params.query) {
        if (userContext.get().roleSystemName === 'Provider') {
            let globalSearch = new BackEnd.TenderRequestSearch.GlobalSearch({
                start: () => this.setState({isLoading: true}),
                end: () => this.setState({isLoading: false})
            });
            let results = await globalSearch.call({
                dto: {
                    numberQuery: query,
                    incomingTenderRequestsPaging: {
                        pageIndex: this.state.incomingTrPageIndex,
                        pageSize: this.props.pageSize
                    },
                    myTenderRequestsPaging: {
                        pageIndex: this.state.acceptedTrPageIndex,
                        pageSize: this.props.pageSize
                    },
                    underwayTenderRequestsPaging: {
                        pageIndex: this.state.underwayTrPageIndex,
                        pageSize: this.props.pageSize
                    },
                    archivedTenderRequestsPaging: {
                        pageIndex: this.state.archivedTrPageIndex,
                        pageSize: this.props.pageSize
                    }
                }
            });

            let totalCount =
                results.incomingTenderRequestsCount +
                results.myTenderRequestsCount +
                results.underwayTenderRequestsCount +
                results.archivedTenderRequestsCount;

            let categoryCount =
                (results.incomingTenderRequestsCount > 0 ? 1 : 0) +
                (results.myTenderRequestsCount > 0 ? 1 : 0) +
                (results.underwayTenderRequestsCount > 0 ? 1 : 0) +
                (results.archivedTenderRequestsCount > 0 ? 1 : 0);

            this.setState({
                results,
                totalCount,
                categoryCount
            });
        }
        else {
            let globalSearch = new BackEnd.TenderSearchOperator.GlobalSearch({
                start: () => this.setState({isLoading: true}),
                end: () => this.setState({isLoading: false})
            });
            let results = await globalSearch.call({
                dto: {
                    numberQuery: query,
                    newTendersPaging: {
                        pageIndex: this.state.newPageIndex,
                        pageSize: this.props.pageSize
                    },
                    activeTendersPaging: {
                        pageIndex: this.state.activePageIndex,
                        pageSize: this.props.pageSize
                    },
                    underwayTendersPaging: {
                        pageIndex: this.state.underwayPageIndex,
                        pageSize: this.props.pageSize
                    },
                    archivedTendersPaging: {
                        pageIndex: this.state.archivedPageIndex,
                        pageSize: this.props.pageSize
                    }
                }
            });

            let totalCount =
                results.newTendersCount +
                results.activeTendersCount +
                results.underwayTendersCount +
                results.archivedTendersCount;

            let categoryCount =
                (results.newTendersCount > 0 ? 1 : 0) +
                (results.activeTendersCount > 0 ? 1 : 0) +
                (results.underwayTendersCount > 0 ? 1 : 0) +
                (results.archivedTendersCount > 0 ? 1 : 0);

            this.setState({
                results,
                totalCount,
                categoryCount
            });
        }
    }
}

export default SearchResults;


// WEBPACK FOOTER //
// ./src/pages/OmniSearch/SearchResults.js